import React from 'react';
import { Card } from "@/components/ui/card";
import { Baby } from 'lucide-react';

interface ChildInfoHeaderProps {
  childName: string;
  dateOfBirth: string;
}

export function ChildInfoHeader({ childName, dateOfBirth }: ChildInfoHeaderProps) {
  const calculateAge = (dob: string): string => {
    const birthDate = new Date(dob);
    const today = new Date();
    
    let years = today.getFullYear() - birthDate.getFullYear();
    let months = today.getMonth() - birthDate.getMonth();
    
    if (months < 0) {
      years--;
      months += 12;
    }
    
    // Adjust if we haven't reached the birth day this month
    if (today.getDate() < birthDate.getDate()) {
      months--;
      if (months < 0) {
        years--;
        months += 12;
      }
    }
    
    if (years === 0) {
      return `${months} ${months === 1 ? 'month' : 'months'} old`;
    } else if (months === 0) {
      return `${years} ${years === 1 ? 'year' : 'years'} old`;
    } else {
      return `${years} ${years === 1 ? 'year' : 'years'} ${months} ${months === 1 ? 'month' : 'months'} old`;
    }
  };

  return (
    <Card className="p-4 bg-gradient-to-br from-purple-50 to-purple-100 border-purple-200 mb-6">
      <div className="flex items-center gap-3">
        <div className="bg-purple-200 p-3 rounded-full">
          <Baby className="h-6 w-6 text-purple-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-purple-900">{childName}</h2>
          <p className="text-sm text-purple-700">{calculateAge(dateOfBirth)}</p>
        </div>
      </div>
    </Card>
  );
}
